import { MatSort, MatSortHeader } from '@angular/material/sort';
import { ParamMap } from '@angular/router';
import { TableQueryParams } from '../models/table-query-params';

export class TableUtils {
  // Sets the Angular Material Sort header in the table programmatically by manually
  // toggling the animation state. Workaround until it's fixed.
  static setSortColumn(matSort: MatSort, column: string) {
    if (matSort && column) {
      const header = matSort.sortables.get(column) as MatSortHeader;
      if (header) header._setAnimationTransitionState({ toState: 'active' });
    }
  }

  static prepareForApiParams(params: TableQueryParams) {
    let { column, sortOrder, start, length, search } = params as any;
    if (sortOrder) {
      sortOrder = sortOrder === 'desc' ? -1 : 1;
    }
    let queryParams: any = params;
    if (start && length) {
      queryParams = {
        ...queryParams,
        start: start.toString(),
        length: length.toString(),
      };
    }
    delete queryParams.sortOrder;
    if (column && sortOrder != null) {
      queryParams.column = column;
      queryParams.order = sortOrder;
    }
    if (search) {
      queryParams.search = encodeURIComponent(search);
    }
    return queryParams;
  }

  static moneyFormatter(value: number) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(value ?? 0); /* 2500 -> $2,500.00 */
  }

  static convertCentsToDollars(value: number) {
    if (!value) return 0;
    return Math.round(value / 100);
  }

  static convertDollarsToCents(value: number) {
    if (!value) return 0;
    return value * 100;
  }

  static arraySum(value: number[]) {
    return value.reduce((x, y) => x + y, 0);
  }

  static parseParams(
    params: ParamMap,
    defaultPage = 0,
    defaultLength = 25,
    defaultColumn?: string,
    defaultSortOrder?: any
  ): TableQueryParams {
    const start = parseInt(params.get('start') || defaultPage.toString(), 10);
    const length = parseInt(params.get('length') || defaultLength.toString(), 10);
    const column = params.get('column') || defaultColumn;
    const sortOrder = (params.get('sortOrder') as any) || defaultSortOrder;

    // pass custom params to api
    const defaultParams = ['start', 'length', 'column', 'sortOrder'];
    const customParams = {};
    for (const key of params.keys.filter((item) => !defaultParams.includes(item))) {
      customParams[key] = params.get(key);
    }

    return Object.assign(
      {},
      start && { start },
      length && { length },
      column && { column },
      sortOrder && { sortOrder },
      customParams
    );
  }
}
